import React from 'react';
import PageWrapper from '../../layout/PageWrapper/PageWrapper';
import { demoPages } from '../../menu';
import Page from '../../layout/Page/Page';
import Card, { CardBody } from '../../components/bootstrap/Card';
import Badge from '../../components/bootstrap/Badge';
import { AutoFixNormal } from '../../components/icon/material-icons';
import Button from '../../components/bootstrap/Button';

const SubscriptionPlan = () => {
    return (
        <PageWrapper title={demoPages.pricingTable.text}>
            <Page container='fluid'>
                <div className='row' style={{ justifyContent: 'center' }}>
                    <div className='col-xl-8 col-sm-12'>
                        <div className='row'>
                            <h4 className='pricing-heading mb-4'>
                                Subscription Plans
                            </h4>
                            {/* STANDARD VERSION */}
                            <div className='col-xl-4 col-md-4 col-lg-4 col-sm-12'>
                                <Card stretch className='pricing-card'>
                                    <CardBody className='pricing-card-body'>
                                        <Badge className='offer-badge'>
                                            <AutoFixNormal fill='#FFF' />{' '}
                                            Current Plan
                                        </Badge>
                                        <h5>Standard Version</h5>
                                        <p>
                                            Essential tools for your social
                                            business
                                        </p>
                                        <div className='features mt-4'>
                                            <p>Includes:</p>
                                            <div
                                                className='d-flex mb-3'
                                                style={{
                                                    alignItems: 'center',
                                                }}>
                                                <img
                                                    src={require('../../assets/check-circle.png')}
                                                    width='18'
                                                    alt='Features'
                                                />
                                                <p
                                                    style={{
                                                        marginBottom: '0px',
                                                        marginLeft: '10px',
                                                    }}>
                                                    <span className='highlight-number'>
                                                        1
                                                    </span>{' '}
                                                    user
                                                </p>
                                            </div>
                                            <div
                                                className='d-flex mb-3'
                                                style={{
                                                    alignItems: 'center',
                                                }}>
                                                <img
                                                    src={require('../../assets/check-circle.png')}
                                                    width='18'
                                                    alt='Features'
                                                />
                                                <p
                                                    style={{
                                                        marginBottom: '0px',
                                                        marginLeft: '10px',
                                                        verticalAlign: 'middle',
                                                    }}>
                                                    <span className='highlight-number'>
                                                        4
                                                    </span>{' '}
                                                    Social Accounts
                                                </p>
                                            </div>
                                            <div
                                                className='d-flex mb-3'
                                                style={{
                                                    alignItems: 'center',
                                                }}>
                                                <img
                                                    src={require('../../assets/check-circle.png')}
                                                    width='18'
                                                    alt='Features'
                                                />
                                                <p
                                                    style={{
                                                        marginBottom: '0px',
                                                        marginLeft: '10px',
                                                        verticalAlign: 'middle',
                                                    }}>
                                                    <span className='highlight-number'>
                                                        Unlimited
                                                    </span>{' '}
                                                    Pending Scheduled Posts
                                                </p>
                                            </div>
                                            <div
                                                className='d-flex mb-3'
                                                style={{
                                                    alignItems: 'center',
                                                }}>
                                                <img
                                                    src={require('../../assets/check-circle.png')}
                                                    width='18'
                                                    alt='Features'
                                                />
                                                <p
                                                    style={{
                                                        marginBottom: '0px',
                                                        marginLeft: '10px',
                                                        verticalAlign: 'middle',
                                                    }}>
                                                    <span className='highlight-number'>
                                                        3
                                                    </span>{' '}
                                                    Days Post History
                                                </p>
                                            </div>
                                            <div
                                                className='d-flex mb-3'
                                                style={{
                                                    alignItems: 'center',
                                                }}>
                                                <img
                                                    src={require('../../assets/check-circle.png')}
                                                    width='18'
                                                    alt='Features'
                                                />
                                                <p
                                                    style={{
                                                        marginBottom: '0px',
                                                        marginLeft: '10px',
                                                        verticalAlign: 'middle',
                                                    }}>
                                                    <span className='highlight-number'>
                                                        Unlimited
                                                    </span>{' '}
                                                    Bulk Upload
                                                </p>
                                            </div>
                                            <div
                                                className='d-flex mb-3'
                                                style={{
                                                    alignItems: 'center',
                                                }}>
                                                <img
                                                    src={require('../../assets/check-circle.png')}
                                                    width='18'
                                                    alt='Features'
                                                />
                                                <p
                                                    style={{
                                                        marginBottom: '0px',
                                                        marginLeft: '10px',
                                                        verticalAlign: 'middle',
                                                    }}>
                                                    <span className='highlight-number'>
                                                        Free
                                                    </span>{' '}
                                                    Tier Support
                                                </p>
                                            </div>
                                            <h5 className='mt-4 mb-4 price-amt'>
                                                $0.00
                                                <span className='price-tag'>
                                                    /per month
                                                </span>
                                            </h5>
                                            <Button color='primary' isOutline>
                                                Unsubscribe Plan
                                            </Button>
                                        </div>
                                    </CardBody>
                                </Card>
                            </div>
                            {/* PROFESSIONAL VERSION */}
                            <div className='col-xl-4 col-md-4 col-lg-4 col-sm-12'>
                                <Card stretch className='pricing-card'>
                                    <CardBody className='pricing-card-body'>
                                        <h5>Professional Version</h5>
                                        <p>
                                            Custom workflows and competitor
                                            reports to mature your social
                                            strategy.
                                        </p>
                                        <div className='features mt-4'>
                                            <p>Includes:</p>
                                            <div
                                                className='d-flex mb-3'
                                                style={{
                                                    alignItems: 'center',
                                                }}>
                                                <img
                                                    src={require('../../assets/check-circle.png')}
                                                    width='18'
                                                    alt='Features'
                                                />
                                                <p
                                                    style={{
                                                        marginBottom: '0px',
                                                        marginLeft: '10px',
                                                    }}>
                                                    <span className='highlight-number'>
                                                        1
                                                    </span>{' '}
                                                    user
                                                </p>
                                            </div>
                                            <div
                                                className='d-flex mb-3'
                                                style={{
                                                    alignItems: 'center',
                                                }}>
                                                <img
                                                    src={require('../../assets/check-circle.png')}
                                                    width='18'
                                                    alt='Features'
                                                />
                                                <p
                                                    style={{
                                                        marginBottom: '0px',
                                                        marginLeft: '10px',
                                                        verticalAlign: 'middle',
                                                    }}>
                                                    <span className='highlight-number'>
                                                        8
                                                    </span>{' '}
                                                    Social Accounts
                                                </p>
                                            </div>
                                            <div
                                                className='d-flex mb-3'
                                                style={{
                                                    alignItems: 'center',
                                                }}>
                                                <img
                                                    src={require('../../assets/check-circle.png')}
                                                    width='18'
                                                    alt='Features'
                                                />
                                                <p
                                                    style={{
                                                        marginBottom: '0px',
                                                        marginLeft: '10px',
                                                        verticalAlign: 'middle',
                                                    }}>
                                                    <span className='highlight-number'>
                                                        Unlimited
                                                    </span>{' '}
                                                    Pending Scheduled Posts
                                                </p>
                                            </div>
                                            <div
                                                className='d-flex mb-3'
                                                style={{
                                                    alignItems: 'center',
                                                }}>
                                                <img
                                                    src={require('../../assets/check-circle.png')}
                                                    width='18'
                                                    alt='Features'
                                                />
                                                <p
                                                    style={{
                                                        marginBottom: '0px',
                                                        marginLeft: '10px',
                                                        verticalAlign: 'middle',
                                                    }}>
                                                    <span className='highlight-number'>
                                                        7
                                                    </span>{' '}
                                                    Days Post History
                                                </p>
                                            </div>
                                            <div
                                                className='d-flex mb-3'
                                                style={{
                                                    alignItems: 'center',
                                                }}>
                                                <img
                                                    src={require('../../assets/check-circle.png')}
                                                    width='18'
                                                    alt='Features'
                                                />
                                                <p
                                                    style={{
                                                        marginBottom: '0px',
                                                        marginLeft: '10px',
                                                        verticalAlign: 'middle',
                                                    }}>
                                                    <span className='highlight-number'>
                                                        Unlimited
                                                    </span>{' '}
                                                    Bulk Upload
                                                </p>
                                            </div>
                                            <div
                                                className='d-flex mb-3'
                                                style={{
                                                    alignItems: 'center',
                                                }}>
                                                <img
                                                    src={require('../../assets/check-circle.png')}
                                                    width='18'
                                                    alt='Features'
                                                />
                                                <p
                                                    style={{
                                                        marginBottom: '0px',
                                                        marginLeft: '10px',
                                                        verticalAlign: 'middle',
                                                    }}>
                                                    <span className='highlight-number'>
                                                        Silver
                                                    </span>{' '}
                                                    Tier Support
                                                </p>
                                            </div>
                                            <h5 className='mt-4 mb-4 price-amt'>
                                                $9.99
                                                <span className='price-tag'>
                                                    /per month
                                                </span>
                                            </h5>
                                            <Button className='gradient-btn-custom'>
                                                Subscribe this plan
                                            </Button>
                                        </div>
                                    </CardBody>
                                </Card>
                            </div>
                            {/* PRO-PREMIUM VERSION */}
                            <div className='col-xl-4 col-md-4 col-lg-4 col-sm-12'>
                                <Card stretch className='pricing-card'>
                                    <CardBody className='pricing-card-body'>
                                        <h5>Pro-Premium Version</h5>
                                        <p>
                                            Automation, collaboration and
                                            enhanced reporting to scale your
                                            business.
                                        </p>
                                        <div className='features mt-4'>
                                            <p>Includes:</p>
                                            <div
                                                className='d-flex mb-3'
                                                style={{
                                                    alignItems: 'center',
                                                }}>
                                                <img
                                                    src={require('../../assets/check-circle.png')}
                                                    width='18'
                                                    alt='Features'
                                                />
                                                <p
                                                    style={{
                                                        marginBottom: '0px',
                                                        marginLeft: '10px',
                                                    }}>
                                                    <span className='highlight-number'>
                                                        1
                                                    </span>{' '}
                                                    user
                                                </p>
                                            </div>
                                            <div
                                                className='d-flex mb-3'
                                                style={{
                                                    alignItems: 'center',
                                                }}>
                                                <img
                                                    src={require('../../assets/check-circle.png')}
                                                    width='18'
                                                    alt='Features'
                                                />
                                                <p
                                                    style={{
                                                        marginBottom: '0px',
                                                        marginLeft: '10px',
                                                        verticalAlign: 'middle',
                                                    }}>
                                                    <span className='highlight-number'>
                                                        12
                                                    </span>{' '}
                                                    Social Accounts
                                                </p>
                                            </div>
                                            <div
                                                className='d-flex mb-3'
                                                style={{
                                                    alignItems: 'center',
                                                }}>
                                                <img
                                                    src={require('../../assets/check-circle.png')}
                                                    width='18'
                                                    alt='Features'
                                                />
                                                <p
                                                    style={{
                                                        marginBottom: '0px',
                                                        marginLeft: '10px',
                                                        verticalAlign: 'middle',
                                                    }}>
                                                    <span className='highlight-number'>
                                                        Unlimited
                                                    </span>{' '}
                                                    Pending Scheduled Posts
                                                </p>
                                            </div>
                                            <div
                                                className='d-flex mb-3'
                                                style={{
                                                    alignItems: 'center',
                                                }}>
                                                <img
                                                    src={require('../../assets/check-circle.png')}
                                                    width='18'
                                                    alt='Features'
                                                />
                                                <p
                                                    style={{
                                                        marginBottom: '0px',
                                                        marginLeft: '10px',
                                                        verticalAlign: 'middle',
                                                    }}>
                                                    <span className='highlight-number'>
                                                        15
                                                    </span>{' '}
                                                    Days Post History
                                                </p>
                                            </div>
                                            <div
                                                className='d-flex mb-3'
                                                style={{
                                                    alignItems: 'center',
                                                }}>
                                                <img
                                                    src={require('../../assets/check-circle.png')}
                                                    width='18'
                                                    alt='Features'
                                                />
                                                <p
                                                    style={{
                                                        marginBottom: '0px',
                                                        marginLeft: '10px',
                                                        verticalAlign: 'middle',
                                                    }}>
                                                    <span className='highlight-number'>
                                                        Unlimited
                                                    </span>{' '}
                                                    Bulk Upload
                                                </p>
                                            </div>
                                            <div
                                                className='d-flex mb-3'
                                                style={{
                                                    alignItems: 'center',
                                                }}>
                                                <img
                                                    src={require('../../assets/check-circle.png')}
                                                    width='18'
                                                    alt='Features'
                                                />
                                                <p
                                                    style={{
                                                        marginBottom: '0px',
                                                        marginLeft: '10px',
                                                        verticalAlign: 'middle',
                                                    }}>
                                                    <span className='highlight-number'>
                                                        Gold
                                                    </span>{' '}
                                                    Tier Support
                                                </p>
                                            </div>
                                            <h5 className='mt-4 mb-4 price-amt'>
                                                $19.99
                                                <span className='price-tag'>
                                                    /per month
                                                </span>
                                            </h5>
                                            <Button className='gradient-btn-custom'>
                                                Subscribe this plan
                                            </Button>
                                        </div>
                                    </CardBody>
                                </Card>
                            </div>
                        </div>
                    </div>
                    <div className='col-xl-3 col-sm-12'>
                        <div className='row'>
                            <h4 className='pricing-heading mb-4'>Summary</h4>
                            <div className='col-xl-12 col-sm-12'>
                                <Card className='summary-card' stretch>
                                    <CardBody>
                                        <div className='payment-selection'>
                                            <div
                                                className='d-flex'
                                                style={{
                                                    alignItems: 'center',
                                                }}>
                                                <input
                                                    type='radio'
                                                    className='radio-btn'
                                                    id='monthly'
                                                    value='monthly'
                                                />
                                                <p
                                                    style={{
                                                        marginBottom: '0px',
                                                        fontSize: '15px',
                                                        marginLeft: '10px',
                                                        fontWeight: '500',
                                                    }}>
                                                    Pay monthly
                                                </p>
                                            </div>
                                            <div
                                                className='d-flex mt-2'
                                                style={{
                                                    alignItems: 'center',
                                                }}>
                                                <input
                                                    type='radio'
                                                    className='radio-btn'
                                                    id='annually'
                                                    value='annually'
                                                />
                                                <p
                                                    style={{
                                                        marginBottom: '0px',
                                                        fontSize: '15px',
                                                        marginLeft: '10px',
                                                        fontWeight: '500',
                                                    }}>
                                                    Pay annually
                                                </p>
                                            </div>
                                        </div>
                                        <div className='border-bottom-custom'>
                                            <div className='subscription-selection'>
                                                <h5
                                                    className='mt-3 mb-3'
                                                    style={{
                                                        fontWeight: '700',
                                                    }}>
                                                    Subscription
                                                </h5>
                                                <div
                                                    className='d-flex'
                                                    style={{
                                                        justifyContent:
                                                            'space-between',
                                                        alignItems: 'center',
                                                    }}>
                                                    <div>
                                                        <p className='plan-name'>
                                                            Standard Plan
                                                        </p>
                                                        <p
                                                            className='plan-desc'
                                                            style={{
                                                                marginBottom:
                                                                    '0px',
                                                            }}>
                                                            $0 per user/month
                                                        </p>
                                                    </div>
                                                    <p className='subscription-amt'>
                                                        $0
                                                    </p>
                                                </div>
                                            </div>
                                            <div className='mt-3'>
                                                <p className='plan-name'>
                                                    Users
                                                </p>
                                                <p className='plan-desc'>
                                                    1 included with plan
                                                </p>
                                            </div>
                                            <div className='mt-3'>
                                                <p className='plan-name'>
                                                    Social Profiles
                                                </p>
                                                <p
                                                    className='plan-desc'
                                                    style={{
                                                        marginBottom: '0px',
                                                    }}>
                                                    5 included with plan
                                                </p>
                                            </div>
                                        </div>
                                        <div className='border-bottom-custom'>
                                            <div
                                                className='d-flex'
                                                style={{
                                                    justifyContent:
                                                        'space-between',
                                                }}>
                                                <h5
                                                    className='mt-3'
                                                    style={{
                                                        fontWeight: '700',
                                                        marginBottom: '0px',
                                                    }}>
                                                    Annual Total
                                                </h5>
                                                <h5
                                                    className='mt-3'
                                                    style={{
                                                        fontWeight: '700',
                                                        marginBottom: '0px',
                                                    }}>
                                                    $0
                                                </h5>
                                            </div>
                                        </div>
                                        <Button
                                            color='primary'
                                            className='mt-3'
                                            style={{ width: '100%' }}>
                                            Proceed
                                        </Button>
                                    </CardBody>
                                </Card>
                            </div>
                        </div>
                    </div>
                </div>
            </Page>
        </PageWrapper>
    );
};

export default SubscriptionPlan;
